import getHelpImage from "@volumental/assets/images/scanner/scannerPicker/get_help.webp";
import { Container } from "@volumental/common";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import { Header } from "../../components/accessible-components";
import { MidJourneyIntro } from "../intro/mid-journey-intro";

interface GetHelpViewProps {
  onClose: () => void;
  onBack: () => void;
  onSelfScan: () => void;
  onAssistedScan: () => void;
}

export function GetHelpView({ onBack, onClose, onSelfScan, onAssistedScan }: GetHelpViewProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <Container>
      <Header close={onClose} back={onBack} />
      <MidJourneyIntro
        onClick={onAssistedScan}
        title={t("getHelp.title")}
        buttonText={t("getHelp.yes")}
        imageSrc={getHelpImage}
        altText={t("imageAlt.getHelp")}
        skipButtonText={t("getHelp.no")}
        onSkip={onSelfScan}
      />
    </Container>
  );
}
